import LoanDetails from "./loans/LoanDetails";
import Plans from "./loans/Plans";
import { Route, Routes } from "react-router-dom";

const Loans = () => {
  return (
    <Routes>
      <Route path="/" element={<Plans />} />
      <Route path=":loanId" element={<LoanDetails />} />
    </Routes>
  );
};

export default Loans;
